











































































































































































































































































































































































import {DataIssue, Issue, IssueConst} from '@/models/Issue'
import {SimpleResponse} from '@/models/Model'
import md5 from 'md5'
import {Component, Vue} from 'vue-property-decorator'
import ItemRow from '../components/Issue/ItemRow.vue'
import TabForDialog from '../components/TabForDialog.vue'
import router from '../router'
import Helper from '../services/Helper.js'

@Component({
  components: {TabForDialog, ItemRow},
})
export default class IssueDialog extends Vue {

  open = false

  md5 = md5

  index = 0
  issues: Issue[] = []
  activeTab: string = 'Info'
  IssueConst = IssueConst

  active_tab = 0

  tabs_info = {
    key: 'info',
    name: 'ข้อมูล',
    click: () => this.click_tab('Info'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0,
  }
  tabs_quotation = {
    key: 'quotation',
    name: 'ใบเสนอราคา',
    click: () => this.click_tab('Quotation'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0,
    isAdded: false,
  }
  tabs_timeline = {
    name: 'Timeline',
    click: () => this.click_tab('Timeline'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: true,
    badge_number: 5,
  }
  tabs = [
    this.tabs_info,
  ]
  dialog: boolean = false
  user_comment: string = ''
  user_comment_saving: boolean = false
  issue: Issue = new Issue()
  isLoadIssue = false
  is_LoadSubmitIssue = false
  is_ApprovingComOption = false
  isPriceLessThanLimit = false
  is_open_quotation: boolean = false
  quotationUrl = ''


  onApply: Function = () => {

  }


  onOpen({id, issue, issues, index, debug, skip_load, onApply}) {
    if (this.open) return
    console.log('Emited', {issue, issues, index, debug})

    this.tabs_quotation.isAdded = false
    this.tabs = this.tabs.filter(tab => tab.key != 'quotation')
    this.activeTab = 'Info'
    this.active_tab = 0


    this.issue = new Issue()
    if (issue) {
      this.issue = issue
    } else if (id) {
      this.issue.id = id
    }
    if (index && issues) {
      this.index = index
      this.issues = issues
    } else {
      this.index = 0
      this.issues = []
    }

    this.open = true
    if (skip_load) {
    } else {
      this.getIssue()
    }
    this.onApply = onApply
  }

  mounted() {
    this.$root.$on('openIssue', this.onOpen)
  }

  onClickPrevious() {
    if (this.issues.length > 1) {
      this.index = (this.index - 1) % this.issues.length
      this.issue = this.issues[this.index]
      this.getIssue()
    }
  }

  onClickNext() {
    if (this.issues.length > 1) {
      this.index = (this.index + 1) % this.issues.length
      this.issue = this.issues[this.index]
      this.getIssue()
    }
  }

  click_tab(name: string): void {
    if (name === 'Cart') {
      this.close()
      router.push('/cart')
    } else {
      this.activeTab = name
    }

  }


  getIssue() {
    const id = this.issue.id
    this.tabs_info.isLoad = true
    Helper.get(Helper.setting.issue.getResourceAPI.replace('{id}', id))
      .then<{ data: DataIssue }>(({data}) => {

        console.log('getIssue', data.data)
        this.issue = data.data


        // this.items = data.data

        //this.$store.commit('issues_response', data)
        //this.reloadItem()
        this.tabs_info.isLoad = false
      }).catch(error => {
      if (error && error.response && error.response.status == 404) {
        this.$root.$emit('onError', {message: 'ไม่พบออร์เดอร์', error: error})
        this.close()
      } else {
        this.$root.$emit('onError', {error: error})
      }
    })

  }

  async ReCartIssue(){
    await this.SetIssueStatus(IssueConst.STATUS_APPROVED_PENDING_OPC)
  }

  async ApproveIssue() {
    await this.SetIssueStatus(IssueConst.STATUS_APPROVED_PENDING_SYNC)
  }

  async RejectIssue() {
    await this.SetIssueStatus(IssueConst.STATUS_REJECT)
  }

  async CancelIssue() {
    await this.SetIssueStatus(IssueConst.STATUS_DRAFT)
    this.close()
  }



  close() {
    this.open = false
  }

  async SetIssueStatus(status: number) {
    if (this.issue.status == status) return
    let issue: Issue = new Issue()
    issue.id = this.issue.id
    issue.mode = 'status'
    if (!issue.hasOwnProperty('SetStatus')) {
      issue = Object.setPrototypeOf(issue, Issue.prototype)
    }
    this.is_LoadSubmitIssue = true
    // debugger
    try {
      issue = await issue.SetStatus(status)
      this.issue = issue
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitIssue = false
    return issue
  }

  async deletingObject(issue: Issue) {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject(issue)
        this.close()
      } else {

      }
    })

  }

  async deleteObject(issue: Issue) {
    // this.is_LoadSubmitIssue = true
    try {
      if (!issue.hasOwnProperty('delete')) {
        issue = Object.setPrototypeOf(issue, Issue.prototype)
      }
      const response: SimpleResponse = await issue.delete()

      this.issues = this.issues.filter(object => object.id != this.issue?.id)

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {message: e.toString(), error: e})
    }

  }

  share(issue: Issue) {

  }

};

